import React, {Component} from 'react';
import {NavBar, TextareaItem, Toast,InputItem,Checkbox,} from 'antd-mobile';
import Upload from 'rc-upload';
import {getLifePrice,lifeAdd,lifeUpload,lifePay} from "../../service/addLines";
import {connect} from "react-redux";
import InfoProtocol from './InfoProtocol'
import "./style.less";
const CheckboxItem = Checkbox.CheckboxItem;
const lifeImg = require('../../common/image/lifeImg.png');
let imageUrl = [];
@connect(
    state => ({userInfo: state.userInfo})
)
export default class FileAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news:"",
            imageUrl:[],
            phone:"",
            contacts:"",
            lifePrice:[
                {name:"全部可见",price:"10元/条"},
                {name:"10km可见",price:"5元/条"},
                {name:"5km可见",price:"2.5元/条"},
            ],
            tabIndex:-1,
            protocolVal:false,//同意协议
            distance:-1,
            totalPrice:0,
            infoProtocol:false,
        };
    }
    componentDidMount() {
        getLifePrice({token:this.props.userInfo.token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({lifePrice:res.data.data,})
            }else{
                Toast.info(res.data.msg,3);
            }
        });

    }

    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    fanweiClick(r,index){
        this.setState({tabIndex:index,distance:r.distance,totalPrice:r.price});
    }
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
    };
    releaseBtn(){
        const {news,imageUrl,contacts,phone,distance,totalPrice,protocolVal}=this.state;
        if(news == ""){
            Toast.info("请输入内容");
            return
        }
        if(contacts == ""){
            Toast.info("请输入联系人");
            return
        }
        if(phone == ""){
            Toast.info("请输入联系电话");
            return
        }
        if(distance == -1){
            Toast.info("请选择可见范围");
            return
        }
        if(protocolVal === false){
            Toast.info("请同意协议");
            return
        }
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                content:news,
                photoList:imageUrl,
                contacts:contacts,
                contactsPhone:phone,
                distance:distance,
                totalPrice:totalPrice,
                releaseLocation:this.props.point.lat  + "_" + this.props.point.lng,
                releaseAddress:this.props.address,
            }
        };
        console.log(params);
        Toast.loading("正在加载", 0);
        lifeAdd(params).then((res) => {
            if (res.data.code === '0000') {
                if(this.state.totalPrice == 0){
                    Toast.info('发布成功',3,()=>this.props.clickBack());
                }else{
                    this.weiXinPay(res.data.data,"wx")
                }
            }else{
                Toast.info(res.data.msg)
            }
        })
    }
    weiXinPay = (orderNo,type) => {
        const params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                source:1,
                orderId: orderNo,
                payChannel:type,
            }
        };
        lifePay(params).then((res)=>{
            if(res.data.code === '0000'){
                this.wxBridgeReady(res);
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    };
    wxBridgeReady = (resp) =>{
        const self = this;
        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": resp.data.data.appId,         //公众号名称，由商户传入
                    "timeStamp": resp.data.data.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": resp.data.data.nonceStr,   //随机串
                    "package": resp.data.data.package,     //prepay_id
                    "signType": resp.data.data.signType,   //微信签名方式
                    "paySign": resp.data.data.sign         //微信签名
                },
                function(res){
                    if(res.err_msg === "get_brand_wcpay_request:ok") {
                        Toast.success("支付成功",2,()=>{
                            self.props.clickBack();
                        });
                    }else if(res.err_msg === "get_brand_wcpay_request:cancel") {
                        Toast.info("支付过程中用户取消");
                    }else if(res.err_msg === "get_brand_wcpay_request:fail") {
                        Toast.fail("支付失败");
                    }else {
                        Toast.fail("未知异常");
                    }
                }
            );
        }
        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    beforeUpload=(file)=> {
        console.log('beforeUpload', file);
        let fileBase64 = "";
        return new Promise((resolve, reject) => {
            // 对文件的信息进行 类型判断
            console.log(resolve, reject);
            let index = file.name.lastIndexOf('.');
            // if (file.name.slice(index) !== ".jpg") {
            //     Toast.info("请上传jpg格式");
            //     reject("请上传jpg格式");
            //     return
            // }
            if(file.size/1024 > 8192){
                Toast.info("上传文件的大小不能超过8M");
                reject("上传文件的大小不能超过8M");
                return
            }
            console.log(imageUrl.length);
            if(imageUrl.length == 5){
                console.log(111111)
                Toast.info("上传不能超过5张");
                return
            }
            // let r = new window.FileReader();
            // r.readAsDataURL(file);
            // r.onload = (e)=>{
            //     this.cutImageBase64(e.target.result,500,(base64 )=>{console.log(base64.length/1024);this.setState({fileData:base64});});
            // };
            // setTimeout(() => {
            //     resolve(file);
            // }, 1000);
            resolve(file);
        })
    };
    onStart=(file) => {
        console.log('onStart', file.name,imageUrl);
        Toast.loading("正在上传",0)
    };
    renxiangCustom = (request) => {
        let formData = new FormData();
        // 创建对象的信息
        formData.append(request.filename, request.file, request.file.name);
        console.log(formData);
        lifeUpload(formData).then((res)=>{
            if(res.data.code == "0000"){
                imageUrl.push(res.data.data.url);
                console.log(imageUrl);
                this.setState({imageUrl});
                Toast.hide();
            }else{
                Toast.info(res.data.msg)
            }
        })
    };
    onClose = () => {
        this.setState({infoProtocol: false,});
    };
    deteleImg(){
        console.log('shanchu')
    }
    render(){
        const uploaderProps = {
            size:'1024',
            beforeUpload:this.beforeUpload,
            onStart: this.onStart,
            customRequest:this.renxiangCustom,
        };
        const {news,phone,contacts} = this.state;
        return(
            <div className="addList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.clickBack()}/>}
                >发布消息</NavBar>
                <div className="content">
                    <div className="top">
                        <p className="title">消息内容</p>
                        <TextareaItem
                            rows={5}
                            placeholder="请输入发布信息内容"
                            value={news}
                            onChange={this.inputChange("news")}
                            onBlur={v => window.scroll(0,0)}
                        />
                        <p className="title"><span>添加照片</span> <span className="num">最多上传5张</span></p>
                        <div className="sfzImg">
                            <Upload
                                capture="camera"
                                {...uploaderProps}
                                id="test"
                                component="div"
                                style={{ display: 'inline-block' }}
                            >
                                {/*<div className="imgBox">
                                    <img src={lifeImg} />
                                    <span onClick={()=>this.deteleImg()}>删除</span>
                                </div>
                                {
                                    this.state.imageUrl && this.state.imageUrl.map((res,i)=>{
                                        return <div className="imgBox">
                                            <img src={res} key={i}/>
                                            <span>删除</span>
                                        </div>
                                    })
                                }*/}
                                {
                                    this.state.imageUrl && this.state.imageUrl.map((res,i)=>{
                                        return <img src={res} key={i}/>
                                    })
                                }
                                {
                                    this.state.imageUrl.length >= 5 ? "" :  <img src={lifeImg} />
                                }
                            </Upload>
                        </div>
                    </div>
                    <div className="contact">
                        <InputItem
                            placeholder="请输入联系人"
                            moneyKeyboardAlign="left"
                            value={contacts}
                            onChange={this.inputChange("contacts")}
                            onBlur={v => window.scroll(0,0)}
                        >联系人</InputItem>
                        <InputItem
                            placeholder="请输入联系电话"
                            moneyKeyboardAlign="left"
                            value={phone}
                            type="number"
                            maxLength={11}
                            onBlur={v => window.scroll(0,0)}
                            onChange={this.inputChange("phone")}
                        >联系电话</InputItem>
                    </div>
                    <div className="bottom">
                        <p className="title">可见范围</p>
                        <div className="infoBox">
                            {
                                this.state.lifePrice.map((res,i)=>(
                                    <div className={this.state.tabIndex == i ? "infoItem active":"infoItem"}  key={i}  onClick={()=>this.fanweiClick(res,i)}>
                                        <p>{res.distance == 0 ? '全部可见' : res.distance + "km可见"}</p>
                                        <p>{res.price}元/条</p>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="info">
                            <p>温馨提示:</p>
                            <p>请勿发布虚假违规违法信息，否则后果自负，交易前请自行判断核时信息真实性，因交易产生一切后果与本平台无关。</p>
                        </div>
                    </div>
                    <div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)} onBlur={v => window.scroll(0,0)}>
                            <span>阅读并同意</span><div onClick={() => this.setState({infoProtocol:true})}>《信息发布用户协议》</div>
                        </CheckboxItem>
                    </div>
                </div>
                <button className='releaseBtn' onClick={()=>this.releaseBtn()}>确认发布</button>
                <InfoProtocol
                    modal={this.state.infoProtocol}
                    onClose={this.onClose.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/FileAdd.js